import { FC } from 'react';
interface Props {
    own: number;
    text?: string;
    titleOnPress?: () => void;
}

const MessageBox: FC<Props> = ({ own, text, titleOnPress }) => {
    const chackUserId = (id: number) => {
        if (id === 0) {
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '10px 0 ',
                        fontFamily: 'sans-serif',
                        fontWeight: '400',
                        cursor: 'pointer',
                    }}
                    onClick={titleOnPress}
                >
                    {text}
                </div>
            );
        }
        return <div></div>;
    };
    return <>{chackUserId(own)}</>;
};

export default MessageBox;
